import {
  Configuration,
  RedirectRequest,
  SilentRequest,
} from "@azure/msal-browser";

export const CLIENT_ID =
  process.env.CLIENT_ID ?? "1e6fe592-7079-40c5-bb9b-62a16fc1ce9c";
export const AUTHORITY =
  process.env.AUTHORITY ??
  "https://login.microsoftonline.com/36108d05-cd24-4516-8b04-694d7b893d17/";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    redirectUri: window.location.origin,
    authority: AUTHORITY,
    postLogoutRedirectUri: `${window.location.origin}/loggedout`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.

const scopes = [`${CLIENT_ID}/.default`];

export const loginRequest: RedirectRequest = {
  scopes,
  prompt: "select_account",
};

export const renewSilentRequest: RedirectRequest = {
  scopes,
};

export const silentRequest: SilentRequest = {
  scopes,
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

// window.location.protocol
export const API_BASE_URL = `https://${window.location.hostname}${
  process.env.NODE_ENV !== "production" ? ":5001" : ""
}`;

export const DIGITRAFFIC_BASE_URL = "https://meri.digitraffic.fi/";

// Localstorage version, used to clear localstorage to avoid issues
export const localstorageVersion = "0.2";
